;(function (angular, _, moment, numeral) {
  'use strict'

  angular
    .module('kilo.routes.quote.list')
    .controller('QuoteListController', QuoteListController)

  QuoteListController.$inject = [
    // Urls
    'urls',

    // Angular
    '$q', '$state', '$http', '$uibModal', '$window', '$scope',

    // Managers
    'TagManager', 'QuoteManager', 'EntityManager', 'OrderManager',

    // Services
    'ComputingService', 'DatePickerService', 'SnackService', 'UtilService',
    'FilterService', 'FilterSidebarService', 'ColumnService', 'SelectionService',
    'PreferencesService', 'DisplayService', 'StatusService',

    // Resolve
    'pagination', 'customFields', 'linkedSearch', 'referers'

  ]

  function QuoteListController (
    // Urls
    urls,

    // Angular
    $q, $state, $http, $uibModal, $window, $scope,

    // Managers
    TagManager, QuoteManager, EntityManager, OrderManager,

    // Services
    ComputingService, DatePickerService, SnackService, UtilService,
    FilterService, FilterSidebarService, ColumnService, SelectionService,
    PreferencesService, DisplayService, StatusService,

    // Resolve
    pagination, customFields, linkedSearch, referers

  ) {
    var self = this

    var customRanges = [
      {
        label: '3 prochains mois',
        range: moment().range(moment().startOf('day'), moment().startOf('day').add(3, 'month'))
      },
      {
        label: '6 prochains mois',
        range: moment().range(moment().startOf('day'), moment().startOf('day').add(6, 'month'))
      },
      {
        label: '1 an',
        range: moment().range(moment().startOf('day'), moment().startOf('day').add(1, 'year'))
      },
      {
        label: '2 ans',
        range: moment().range(moment().startOf('day'), moment().startOf('day').add(2, 'year'))
      }
    ]

    var customRangeSignAndEm = [
      {
        label: 'année dernière',
        range: moment().range(moment().startOf('years').subtract(1, 'years'), moment().endOf('years').subtract(1, 'years'))
      },
      {
        label: 'mois dernier',
        range: moment().range(moment().startOf('month').subtract(1, 'months'), moment().endOf('month').subtract(1, 'months'))
      },
      {
        label: 'semaine dernière',
        range: moment().range(moment().startOf('week').subtract(1, 'weeks'), moment().endOf('week').subtract(1, 'weeks'))
      },
      {
        label: 'hier',
        range: moment().range(moment().startOf('day').subtract(1, 'days'), moment().endOf('day').subtract(1, 'days'))
      },
      {
        label: 'aujourd\'hui',
        range: moment().range(moment().startOf('day'), moment().endOf('day'))
      }
    ]

    self.$onInit = () => {
      _.extend(self, {

        // Attributes
        pagination: pagination,
        manager: QuoteManager,
        customFields: customFields,
        referers: referers,
        statuses: StatusService.getStatuses('quote'),
        archive: [
          { label: 'Non-archivées', value: false, _id: 'archived' },
          { label: 'Archivées', value: true, _id: 'archived' },
          { label: 'Toutes', value: 'both', _id: 'archived' }
        ],
        types: [
          { label: 'Avec Acompte', v: true, _id: 'invoiceDeposit' },
          { label: 'Sans Acompte', v: false, _id: 'invoiceDeposit' }
        ],
        sideBar: FilterSidebarService,
        ColumnService: ColumnService,
        selection: SelectionService.getSelection(),

        // Methods
        addCriteria: addCriteria,
        archiveQuote: archiveQuote,
        asCsv: asCsv,
        asPdf: asPdf,
        asSpreadsheet: asSpreadsheet,
        clearSearch: clearSearch,
        duplicate: duplicate,
        groupFind: FilterService.groupFind,
        fullTotalFallback: fullTotalFallback,
        getDateColor: getDateColor,
        getFullTotal: getFullTotal,
        getQuoteDiscountedTotal: getQuoteDiscountedTotal,
        getInvoiceNumber: getInvoiceNumber,
        getList: getList,
        go: go,
        isVisible: isVisible,
        newTab: newTab,
        restoreQuote: restoreQuote,
        searchQuoteRef: searchQuoteRef,
        searchQuoteTitle: searchQuoteTitle,
        searchClients: searchClients,
        searchTags: searchTags,
        selectDateRange: selectDateRange,
        selectCreatedAtRange: selectCreatedAtRange,
        selectDueDateRange: selectDueDateRange,
        selectTag: selectTag,
        dropColumn: dropColumn,
        saveColumns: saveColumns,
        resetColumns: resetColumns,
        isCustomField: isCustomField,
        isCompanyPrefsValid: isCompanyPrefsValid,
        sort: sort,
        searchBpus: searchBpus,
        searchDeliveries: searchDeliveries,
        showInterventions: showInterventions,
        searchClientsNumber: searchClientsNumber
      })

      // Colonnes visibles uniquement (dans l'ordre de self.columns), itérées par le template
      // à la place de self.columns + ng-if="isVisible(col.id)" (toutes les colonnes x N lignes à chaque digest).
      // self.columns est réaffecté (init, saveColumns, resetColumns, dropColumn) mais aussi muté en
      // place (splice de dropColumn, ColumnService.loadNewColumns sur le tableau des préférences) :
      // un seul $watchGroup, non profond, sur la référence du tableau + une signature id:visible.
      $scope.$watchGroup([
        () => self.columns,
        () => self.columns && self.columns.map(c => c.id + ':' + !!c.visible).join(',')
      ], updateVisibleColumns)
      // Index des clés de champs perso, lu par chaque cellule à la place de isCustomField(col.id)
      // (_.map de tous les champs perso par cellule et par digest). Recalculé si la liste est réaffectée.
      $scope.$watch(() => self.customFields, updateCustomFieldIds)
      $scope.$on('QuoteBulkValidate', refreshList)

      init()
    }

    function init () {
      self.sideBar.init()
      self.ColumnService.init()
      PreferencesService.getPrefsFor('company').then(function (companyPrefs) {
        self.noFilter = _.get(companyPrefs.enabledFeatures, 'noFilters', false)
        self.allowArchiveAndRestore = !companyPrefs.enabledFeatures.allowArchiveAndRestore
        PreferencesService.getPrefsFor('general').then(function (prefs) {
          self.prefs = prefs
          self.columns = UtilService.updateColumnList(ColumnService.getColumns('quote'), self.customFields, ColumnService.getDefaultColumns('quote'))
          self.sideBarColumns = UtilService.updateColumnList(ColumnService.getColumns('quote'), self.customFields, ColumnService.getDefaultColumns('quote'))
          if (self.noFilter) {
            self.pagination.search = {}
            self.pagination.currentPage = 0
          }
          if (prefs.hasOwnProperty('settings')) {
            if (_.get(prefs.settings.quoteList, 'pagination')) {
              self.pagination.perPage = _.get(prefs.settings.quoteList, 'pagination')
            }
            if (_.get(prefs.settings, 'sideBarVisible')) {
              self.sideBar.filterVisible = _.get(prefs.settings, 'sideBarVisible')
            }
          }
          self.selection.selectedData = []
          if (linkedSearch && !angular.equals({}, linkedSearch)) {
            self.sideBar.filterVisible = true
            initLinkedSearch()
          } else {
            getList()
          }
        })
      })
    }

    function isCompanyPrefsValid () {
      return PreferencesService.isCompanyPrefsValid()
    }

    function isCustomField (key) {
      return _.includes(_.map(self.customFields, 'key'), key)
    }

    function showInterventions (quote) {
      if (!quote?.linkedData?.solica?.interventions?.length) {
        return goTo(quote)
      }

      return $uibModal.open({
        size: 'xl',
        component: 'linkedInterventionsModal',
        resolve: { quote
        }
      })
    }

    function goTo (quote) {
      if (quote.type && quote.type === 'situation') {
        OrderManager.get(
          OrderManager
            .query({
              conditions: {
                quotes: quote._id
              },
              populate: JSON.stringify([
                { path: 'quotes' }
              ])
            })
            .fields('quotes')
        ).then(function (data) {
          var order = data.data[0]
          var arrayIndex = _.findIndex(order.quotes, function (elt) {
            return elt._id === quote._id
          })
          var objIndex = order.quotes.length - arrayIndex
          $state.go('order.show', {
            id: order._id,
            initParams: {
              tabIndex: arrayIndex + 1,
              objIndex: objIndex,
              obj: order.quotes[arrayIndex]
            }
          })
        })
      } else {
        $state.go('quote.show', { id: quote._id })
      }
    }

    function saveColumns (changedCol) {
      let index = self.prefs.settings.quoteList.columns.findIndex(element => element.id === changedCol.id)
      self.prefs.settings.quoteList.columns[index].visible = changedCol.visible
      self.prefs.save().then(function (data) {
        self.columns = ColumnService.getColumns('quote')
      })
    }

    function resetColumns () {
      self.prefs.settings.quoteList.columns = UtilService.updateColumnList(ColumnService.getDefaultColumns('quote'), self.customFields, ColumnService.getDefaultColumns('quote'))
      self.prefs.save().then(function (data) {
        self.columns = ColumnService.getColumns('quote')
        self.sideBarColumns = ColumnService.getColumns('quote')
      })
    }

    function refreshList () {
      if (self.selection.selectedData && self.selection.selectedData.length) {
        self.selection.selectedData = []
      }
      self.sideBar.init()
      getList()
    }

    function initLinkedSearch () {
      if (
        linkedSearch.hasOwnProperty('status') ||
        linkedSearch.hasOwnProperty('client') ||
        linkedSearch.hasOwnProperty('label')
      ) {
        self.pagination.search = {}
        if (linkedSearch.status) {
          self.pagination.search = FilterService.addCriteria(self.pagination.search, 'status', _.find(self.statuses, function (s) { return s.status === linkedSearch.status }))
        }
        if (linkedSearch.client && linkedSearch.label) {
          self.pagination.search = FilterService.addCriteria(self.pagination.search, 'client', { _id: linkedSearch.client, label: linkedSearch.label })
        }
      } else {
        self.pagination.search = linkedSearch
      }
      getList()
    }

    function dropColumn (source, target) {
      var newIndex = _.findIndex(self.columns, { id: target })
      var oldIndex = _.findIndex(self.columns, { id: source })
      self.columns.splice(newIndex, 0, self.columns.splice(oldIndex, 1)[0])
      self.prefs.save().then(function () {
        self.columns = ColumnService.getColumns('quote')
      })
    }

    function archiveQuote (quote) {
      var content = "Vous êtes sur le point d'archiver ce devis.<br><br>Vous ne pourrez plus le modifier ni le dupliquer.<br><br>Êtes-vous sûr de vouloir continuer ?"
      DisplayService.displayConfirm('Archiver', content).then(function () {
        quote.archive().then(function () {
          SnackService.snack({
            text: 'Devis archivé !',
            delay: 5000
          })
          $state.reload()
        })
      })
    }

    function restoreQuote (quote) {
      var content = 'Vous êtes sur le point de restaurer ce devis.<br><br>Êtes-vous sûr de vouloir continuer ?'
      DisplayService.displayConfirm('Restaurer', content).then(function () {
        quote.restore().then(function () {
          SnackService.snack({
            text: 'Devis restauré !',
            delay: 5000
          })
          $state.reload()
        })
      })
    }

    function newTab (id) {
      var url = $state.href('quote.show', { id: id })
      $window.open(url, '_blank')
    }

    function duplicate (quote) {
      QuoteManager.findById(quote._id, QuoteManager.query({
        populate: JSON.stringify([
          { path: 'referers' },
          { path: 'tags' }
        ])
      })).then(function (completeQuote) {
        PreferencesService.getPrefsFor('quote').then(function (prefs) {
          var dup = QuoteManager.create(completeQuote.duplicate())
          $state.go('quote.new', { initParams: dup })
          SnackService.snack({
            text: 'Devis dupliqué !',
            delay: 5000
          })
        })
      })
    }

    function go (quote) {
      $state.go('quote.show', { id: quote })
    }

    function asPdf (quoteId) {
      return $uibModal.open({
        controllerAs: 'select',
        bindToController: true,
        resolve: {
          type: function () { return 'quote' }
        },
        templateUrl: '/app/common/layouts/partials/modals/select-template.html',
        controller: 'SelectTemplateController'
      }).result.then(function (template) {
        var url = urls.backend + '/services/pdf/quote/'
        if (template !== false) {
          url += template._id
        }
        $http.post(url, { quotes: [quoteId] }).then(
          function (d) {
            SnackService.snack({
              text: 'Devis exporté en PDF !',
              delay: 5000
            })
          })
      })
    }

    function asCsv (quoteId) {
      var url = urls.backend + '/services/csv/quotes/'
      $http.post(url, { quotes: [quoteId] }).then(
        function (d) {
          SnackService.snack({
            text: 'Devis exporté en CSV !',
            delay: 5000
          })
        })
    }

    function asSpreadsheet (quoteId) {
      var url = urls.backend + '/services/spreadsheet/quotes/'
      $http.post(url, { quotes: [quoteId] }).then(
        function (d) {
          SnackService.snack({
            text: 'Devis exporté en feuille de calcul !',
            delay: 5000
          })
        })
    }

    function getDateColor (invoice) {
      if (invoice.status !== 'invoiced') {
        if (moment().isAfter(moment(invoice.dueDate))) {
          return 'red'
        }
        if (moment(invoice.dueDate).subtract(5, 'days') < moment()) {
          return 'orange'
        }
      }
    }

    function sort (name) {
      this.reverse = (self.pagination.orderBy === name) ? !this.reverse : false
      self.pagination.orderBy = name
      self.pagination.reverse = this.reverse
      getList()
    }

    function getInvoiceNumber (quote) {
      if (quote.status === 'draft') return 'Brouillon'
      return UtilService.getInvoiceNumber(quote, 'quote', quote.numberFormat)
    }

    function selectTag (tag) {
      if (tag._id) {
        self.pagination.search.tag = tag._id
      }
      getList()
    }

    function getFullTotal (quote) {
      var vats = _.reduce(quote.lines,
        function (acc, line) {
          if (line.type === 'label') return acc
          var vat = line.VAT
          var vatTotal = _.find(acc, { vat: vat })
          if (!vatTotal) {
            vatTotal = { vat: vat, amount: 0 }
            acc.push(vatTotal)
          }
          vatTotal.amount += line.discountedTotal * line.VAT / 100
          return acc
        }, [])
      var total = _.reduce(quote.lines,
        function (acc, line) {
          if (line.type === 'label') return acc
          return acc + line.discountedTotal
        }, 0)
      return total + _.reduce(vats, function (acc, vat) { return acc + vat.amount }, 0)
    }

    function getQuoteDiscountedTotal (quote) {
      if (_.get(quote, 'discountedTotal')) return quote.discountedTotal
      return ComputingService.getObjectDiscountedTotal(quote.lines, quote)
    }

    function fullTotalFallback (quote) {
      if (!quote.fullTotal || (quote.fullTotal === 0 && quote.total !== 0)) {
        return self.getFullTotal(quote)
      }
      return quote.fullTotal
    }

    function updateVisibleColumns () {
      self.visibleColumns = _.filter(self.columns, 'visible')
    }

    function updateCustomFieldIds () {
      // Objet sans prototype : un id de colonne comme 'constructor' ne doit pas être vu comme champ perso
      const ids = Object.create(null)
      _.forEach(self.customFields, function (field) {
        ids[field.key] = true
      })
      self.customFieldIds = ids
    }

    function isVisible (columnId) {
      if (!self.columns) {
        return
      }
      for (var i = 0; i < self.columns.length; i++) {
        if (self.columns[i].id === columnId) {
          return self.columns[i].visible
        }
      }
      return false
    }

    // SEARCH

    function getList () {
      self.pagination.search = FilterService.sanitizeSearchTree(self.pagination.search, true)
      self.pagination.save()
      self.loading = true
      self.pagination.orderBy = self.pagination.orderBy || '-createdAt'

      if (_.isEmpty(self.pagination.search)) {
        addCriteria('isArchived', { _id: 'archived', value: false })
        return
      }

      var q = {
        populate: JSON.stringify([
          {
            path: 'client',
            select: '__t type number label address'
          },
          {
            path: 'delivery',
            select: '__t type number label address'
          },
          {
            path: 'tags',
            select: 'color label'
          },
          { path: 'referers' },
          { path: 'bpu' }
          // linkedData.solica.interventions n'est plus peuplé : la liste n'en affiche que le
          // nombre (ids), la modale linkedInterventionsModal charge elle-même les interventions
        ]),
        archived: String(FilterService.hasArchivedCriteria(self.pagination.search, true))
      }

      var query =
        QuoteManager
          .query(q)
          .paginate(self.pagination.toQueryOptions())

      if (self.pagination.search) {
        query.setQuery(FilterService.parseQueryTree(self.pagination.search))
      }
      if (query.opts.conditions.$and) {
        query.opts.conditions.$and.push({ isModel: { $exists: false } })
      } else {
        query.opts.conditions = {
          ...query.opts.conditions,
          isModel: { $exists: false }
        }
      }

      // TODO HANDLE LINKED SEARCH

      var promise = QuoteManager.post(query, { ignoreArchived: true })
      promise.then(function (data) {
        self.quotes = _.map(data.data, function (quote) {
          quote.lastStatusDate = _.get(_.last(quote.history), 'date')
          return quote
        })
        self.pagination.totalElements = data.meta.total
        self.pagination.save()
        self.loading = false

        // Reset the pagination if we try to load page without results
        if (data.meta.total > 0 && !self.quotes.length && self.pagination.currentPage >= 0) {
          pagination.currentPage = 0
          getList(pagination)
        }
      })
    }

    function addCriteria (key, value, negation) {
      if (value !== undefined && value !== null) {
        self.pagination.search = FilterService.addCriteria(self.pagination.search, key, value, negation)
        getList()
      }
    }

    function clearSearch () {
      self.pagination.search = {}
      getList()
    }

    function searchQuoteRef (search) {
      return FilterService.searchQuoteRef(search).then(function (refs) {
        self.refs = refs
      })
    }

    function searchQuoteTitle (search) {
      return FilterService.searchQuoteTitle(search).then(function (titles) {
        self.titles = titles
      })
    }

    function searchTags (query) {
      return FilterService.searchTags(query)
    }

    function searchClients (search) {
      if (search) {
        return FilterService.searchClients(search, ['Organization', 'Agency', 'Contact']).then(function (data) {
          self.clients = data
        })
      }
    }

    function searchClientsNumber (search) {
      if (search) {
        FilterService.searchClientsNumber(search, ['Organization', 'Agency', 'Contact']).then(function (data) {
          self.clients = data
        })
      }
    }

    function searchDeliveries (search) {
      if (search) {
        FilterService.searchClients(search, ['Individual', 'Organization', 'Agency', 'Professional', 'Area', 'Housing']).then(function (data) {
          self.deliveries = data
        })
      }
    }

    function selectDateRange (sign = false) {
      DatePickerService.getRange(self.pagination.search.date, {
        showRanged: true,
        customSelectOptions: customRangeSignAndEm
      }).then(function (dates) {
        dates.start.utcOffset(0, true)
        dates.end.utcOffset(0, true)
        if (!sign) {
          addCriteria('date', dates)
        } else {
          addCriteria('signDate', dates)
        }
        getList()
      })
    }

    function selectCreatedAtRange () {
      DatePickerService.getRange(self.pagination.search.createdAt, {
        showRanged: true,
        customSelectOptions: customRangeSignAndEm
      }).then(function (dates) {
        dates.start.utcOffset(0, true)
        dates.end.utcOffset(0, true)
        addCriteria('createdAt', dates)
        getList()
      })
    }

    function selectDueDateRange () {
      DatePickerService.getRange(self.pagination.search.dueDate, {
        showRanged: true,
        customSelectOptions: customRanges
      }).then(function (dates) {
        addCriteria('dueDate', dates)
        getList()
      })
    }

    function searchBpus (search) {
      return FilterService.searchBpu(search).then(function (bpus) {
        self.bpus = bpus
      })
    }
  }
})(window.angular, window._, window.moment, window.numeral)
